
/**
* Events
*	Triggers
*		STT-start-complete
*/

var SAMPLE_RATE = 16000;
var ENCODING = 'LINEAR16';
var constraints = { audio: true, channelCount: 1, autoStart: false, sampleRate: SAMPLE_RATE, autoGainControl: true, echoCancellation: true, noiseSuppression: true };

const AudioCtx = window.AudioContext || window.webkitAudioContext;

var stream, audioInput, scriptNode, audioProcessor, audioContext, ondataavailable;

var initialised = false;

function initialise() {
	if(initialised) return;
	initialised = true;

	audioContext = new AudioCtx();
	scriptNode = audioContext.createScriptProcessor(4096, 1, 1);
	audioProcessor = new Worker(vidbaby.libraryPath + '/libs/audioProcessor.js');

	audioProcessor.postMessage(audioContext.sampleRate);

	audioProcessor.onmessage = e => {
		pcm.ondataavailable({ audio: e.data, encoding: ENCODING, languageCode: 'en-US', sampleRateHertz: SAMPLE_RATE });
	};

	scriptNode.onaudioprocess = (data) => {
		audioProcessor.postMessage(data.inputBuffer.getChannelData(0));
	};
}

function hasGetUserMedia() {
	return !!(navigator.mediaDevices &&
		navigator.mediaDevices.getUserMedia);
}

var pcm = {
	ondataavailable,
	async start() {
  if (!hasGetUserMedia()) {
		  alert('This browser does not support microphone access.');
      return;
	  }
		initialise();
		stream = await navigator.mediaDevices.getUserMedia(constraints);
		
		audioInput = audioContext.createMediaStreamSource(stream);

		audioInput.connect(scriptNode);
		scriptNode.connect(audioContext.destination);
	},
	stop() {
		if (stream && typeof stream.getTracks == 'function') {
			stream.getTracks().forEach(track => {
				track.stop();
				stream.removeTrack(track);
			});
			audioInput.disconnect(scriptNode);
			
			if(scriptNode) scriptNode.disconnect(0);
			stream = null;
		}
	}
};

export default pcm;